// extracted by mini-css-extract-plugin
export default {"root":"DeleteFlagModal_root__DRIUF","container":"DeleteFlagModal_container__2fraG"};